import { Component, OnInit, Input,ViewChild } from '@angular/core';
import { NavParams, ModalController,Platform ,IonInfiniteScroll} from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { MessageclientService } from 'src/service/messageclient.service';
import { ActivatedRoute } from '@angular/router';
import { WebParameterContext,WebResponesContext } from 'src/model/common';
declare var app;
@Component({
  selector: 'app-publicselection',
  templateUrl: './publicselection.page.html',
  styleUrls: ['./publicselection.page.scss'],
})
export class PublicselectionPage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  dataArrayList: any = {};
  
  dataArrayTitle: Array<any> = []; //分类主题
  PageNumber:number=1;//当前第几页 默认第一页
  step: number = 0;
  AId : any; 
  num: number = 0; // 选中的第几个
  apiObj = {
    status: false,
    msg: ''
};//接口状态
loading: boolean = false;//加载效果
isSearch:boolean = true;//获取是否有查询条件
RecordCount: Number = 0;//列表总数量
searchValue:any="";//查询条件
 webRespone:WebResponesContext = new WebResponesContext();//返回结果处理对象
 checkedAll:boolean=false;//判断是权限or反选；
 typeID:any=null;//存储类型ID，默认加载类型下标第一个；
 typeCode:any = null;// 存储类型CodeID
 messageShow :boolean = false;// 选中消息提示
 checkItem:any={};//获取选中的对象
  constructor(
    private platform: Platform,
    public modalController: ModalController,
    public  navParams: NavParams,
    public http:HttpCustomerService,
    public com:CommonService,
    public msg:MessageclientService,
    private activaRouter: ActivatedRoute

  ) {
    console.log(navParams.get('firstName'));
  }
  ngOnInit() {
    const that =this;
    // this.initCheckedIdArr();
    this.LoadDataList();
    // console.log("that.dataArrayList数据数据数据")
      console.log(this.dataArrayList.length)
    console.log(that["typeItem"]);
    console.log(that["codetype"]);
    // console.log(that["a_TelPhone"])
  
    
  }
   /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e,type:string = 'type'){ 
    const that=this;
    if(e.keyCode == 13 || type=='search'){
      that.LoadData(1);
      // this.LoadDataInfo(1);
    }
  }
   /**
   * 加载类型的列表
   * @param num 对应列表
   */
  btn_change(num,item){
    const that=this;
    if(that.step == num){
      that.step = 0;
    }else{
      that.step = num;
    }
    that.typeID=item["a_ID"];
    that.typeCode = item["a_Code"];
    if(!that.dataArrayList[that.typeCode]){
      that.LoadData(1);
    }
  }
  // 取消按钮
  dismissModal() {
    const that=this;
    that.webRespone.Status=new Array<any>();
    that.webRespone.ResponseMessage.Success=false;
    that.modalController.dismiss({
      "result":  that.webRespone,
      "checked":that.checkedAll
    });
  }
/**
 * 上拉分页
 * @param event 
 */
  loadMoreData(event) {
    let that = this;
    console.log("that.dataArrayList数据数据数据")
      console.log(that.dataArrayList);
    if (that.RecordCount == that.dataArrayList[that.typeCode].length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
    } else {
      that.PageNumber++;
      that.LoadData(that.PageNumber);
    }
  }

  /**
   * 
   * @param 选项主要类别
   */
  LoadDataList(){
    let that = this;
const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let id = that.activaRouter.snapshot.paramMap.get('id');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName="MemberGift";
  body.OpType = "query";
  body.ConfigType = "view";
  body.RowsPerPage = app.RowsPerPage;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = "publicselection";
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  body.RequestBody = {};
  if(that.com.GetStorageKey("meminfo")){
    body.RequestBody={"userid":that.com.GetStorageKey("meminfo")["id"].value};
  }
 
  if(that["typeItem"]){
    body.RequestBody["type"]=1;
  }
  if(that["a_TelPhone"]){
    body.RequestBody["telphone"] = that["a_TelPhone"];
  }
  that.msg.Loading("加载中，请稍后...").then(load=>{
  body.RequestBody = JSON.stringify(body.RequestBody);
  that.http.post(app.DEFAULTURL, body).then(data => {
     load.dismiss();
    if (data.ResponseMessage.Success) {
      console.log(data);
      console.log(data.Status);
      if( data.Status.Datas.length>0){
        console.log(data.Status.Datas,"88888888888888888888888888888888888888888888888888888888888");
        that.typeID=data.Status.Datas[0]["ID"];
        that.typeCode=data.Status.Datas[0]["Code"];
        // console.log(data.Status.datas);
        data.Status.Datas.forEach(ite=>{
          let jemTit :any = {};
          jemTit["a_ID"]=ite.ID;//赠品主键
          jemTit["a_Name"]=ite.Name;//赠品名称
          jemTit["a_IsValid"]=false;
          jemTit["a_Code"]=ite.Code;//赠品名称
          jemTit["sum_ChineseName"]=ite.Name;//赠品名称
          that.dataArrayTitle.push(jemTit);
          // 过滤类型不为空的情况
          that.dataArrayTitle = that.dataArrayTitle.filter(item => item.a_Name!=null);
          console.log("zm");
          console.log( that.dataArrayTitle);
        });
        that.LoadData(1);
      }else{
        that.loading=true;
      }
      console.log( that.dataArrayTitle.length,"kkkkkkkkkk")
      console.log(that.dataArrayList)
     
    }
  }).catch(error => {
     load.dismiss();
    that.apiObj['status'] = false;
    that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
    that.loading = true;
    console.log(error);
  });
   load.present();
    })
  }
  /**
   * 请求数据列表
   * @param PageNumber 当前页数
   */
  LoadData(PageNumber){
  let that = this;
  that.PageNumber = PageNumber;
  if (PageNumber == 1) {
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    that.dataArrayList[that.typeCode] = [];
  }
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let id = that.activaRouter.snapshot.paramMap.get('id');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  // body.ConfigName ="GetSaleServiceList";
  // body.ConfigName="GiftsCategory";
  body.ConfigName="TBGiftStockByStoreXML";
  body.OpType = "query";
  body.ConfigType = "view";
  // body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = PageNumber;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = "publicselection";
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  if(that["a_TelPhone"]){
    body.SpecialParameter = that["a_TelPhone"]
  }
  body.RequestBody={};
  // body.RequestBody["a_FK_TBProductInformation_ID"]=that["ids"];//获取产品ID；
  body.RequestBody ["tbg_FK_GiftsCategory_ID"] = that.typeID;
  body.RequestBody ["a_FK_TBStore_ID"] = that.com.GetStorageKey("tbstore")["ID"];
  body.RequestBody["codeType"] = that["codetype"];

  if(that.searchValue){
    body.RequestBody["tbg_Name"]=that.com.LikeSearch(that.searchValue);
  }
  // let orderDate = that.com.BetweenDate(that.month+" 00:00:00",that.month+" 23:59:59");
  body.RequestBody = JSON.stringify(body.RequestBody);
  // that.msg.Loading("加载中，请稍后...").then(load=>{
  that.http.post(app.DEFAULTURL, body).then(data => {
    // load.dismiss();
    // console.log("数据显示++++++++++++++++++++++++++++")
    // console.log(data)
    /****判断是否第一页begin****/
    if(PageNumber == 1){
      that.apiObj['status'] = data.ResponseMessage.Success;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
    }else{
      if( that.infiniteScroll){
        that.infiniteScroll.complete();
      }
     
    }
    /****判断是否第一页end****/
    if (data.ResponseMessage.Success) {
      console.log(data);
      console.log("that.dataArrayList数据数据数据")
      console.log(that.dataArrayList);
      data.Status.Datas.forEach(function (item) {
        if(item.a_Name!==null){
          let objtemp:any={};
          objtemp["id"]=item.a_ID;//赠品主键
          objtemp["pid"]=that.typeID;//类别ID
          objtemp["checked"]=false;//默认未选中
          const ids:any= that["checkItem"];//获取选中的id
           objtemp["Num"]=0;
          if(ids){
            ids.forEach(fid=>{
              if(fid.id==item.a_ID && fid.pid==that.typeID){
                objtemp["checked"]=true;
                if(fid.Num){
                  objtemp["Num"]=fid.Num;
                }
               }
            });
          }
          objtemp["Name"]=item.tbg_Name;//赠品名称
          objtemp["Stock"]=item.a_Stock||1;//赠品数量
          objtemp["Code"]=item.b_Code;//赠品类别WW
          objtemp["StoreName"]=item.tbg_Name;//赠品名称
         
  
          that.dataArrayList[that.typeCode].push(objtemp);
          console.log("选中的数据选中的数据")
          // console.log(that.dataArrayList[that.typeCode]);
        }
     
      });
      /****上拉加载数据begin****/
         that.RecordCount = data.Status.RecordCount;
      if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList[that.typeCode].length){
        // that.infiniteScroll.disabled = true;
        if( that.infiniteScroll){
          that.infiniteScroll.disabled = true;
        }
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.disabled = false;
        }
      }
      /****上拉加载数据end****/
    }else{
      // that.dataArrayList=new Array<any>();
      that.apiObj['status'] = false;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
    }

  }).catch(error => {
    // load.dismiss();
    that.apiObj['status'] = false;
    that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
    that.loading = true;
    console.log(error);
  });
  // load.present();
// })
}
    /**
   * 下拉刷新数据
   * @param event
   */
  doRefresh(event){
    const that=this;
    // console.log("下拉率先你");
    if(that.typeCode){
      that.LoadData(1);
    }
    // console.log(event);
    event.target.pullMax=500;
    event.target.pullMin=100;
    // console.log(this.ionRefresh);
    event.target.complete();
  }
  /**
   * 确认事件
   */
  comfireModal() {
    const that=this;
    console.log("确认按钮");
    // that.msg.Alert("请选择礼品类型","提示框","确定").then(data=>{
           
    // })
    
    let ids:Array<any>= that["checkItem"]||[];//获取选中的id
    console.log(ids,"nengnrkngkhe");
    console.log(ids.length);
    that.webRespone.Status=new Array<any>();
    that.webRespone.ResponseMessage.Success=true;
    that.dataArrayTitle.forEach(itm=>{
        if(that.dataArrayList[itm.a_Code]){
            that.dataArrayList[itm.a_Code].forEach(ck=>{
              ck.pid=itm.a_ID;
              if(ck.checked){
                if(!ck.Num){
                  ck.Num=1;
                }
                if(ids.length<=0){
                  ids.push(ck);
                }else{
                  if(ids.find(ts=>ts.Code==itm.a_Code && ts.pid==itm.a_ID)){
                    ids.find(ts=>ts.Code==itm.a_Code && ts.pid==itm.a_ID)["id"]=ck.id;
                    ids.find(ts=>ts.Code==itm.a_Code && ts.pid==itm.a_ID)["Name"]=ck.Name;
                    ids.find(ts=>ts.Code==itm.a_Code && ts.pid==itm.a_ID)["Num"]=ck.Num;
                  }else{
                    ids.push(ck);
                  }
                }
              }else{
                if(ids.length>0){
                  if(ids.find(ts=>ts.Code==itm.a_Code && ts.id==ck.id && ts.pid==ck.pid)){
                    ids.forEach((t,i)=>{
                      if(t.id==ck.id){
                        ids.splice(i,1);
                      }
                    })
                  }
                }
              }
            });
        }
    });
    if(ids.length>0){
      let isnum:boolean=true;
      ids.forEach(item=>{
        if(!item.Num){
          isnum=false;
        }
      });
      if(!isnum){
        that.msg.Alert("请填写选择的礼品数量");
        return;
      }
    }
    that.webRespone.Status=ids;
   /**
    * 没选择类型提示框
    */
    // if(that.webRespone.Status.length===0 || !that.com.GetStorageKey("homing")){
    //   that.msg.Alert("请至少选择一种礼品哦！","提示框","确定");
    //   return;
             
    // }
   
    this.modalController.dismiss({
      "result": that.webRespone,
      "checked":that.checkedAll
    });
  }
  /**
   * 公共礼品选择
   * @param item 当前点击项
   */
  onInput(item,e) {
    const that=this;
    if(that.dataArrayList[that.typeCode]){
      that.dataArrayList[that.typeCode].forEach(ck=>{
        
        if( e.target.checked){
          ck.checked==!e.target.checked;
          ck.checked = false;
        }
           
      });
    }
    
    item.checked=e.target.checked;
    // console.log(item.checked);
  //  if( item.checked){
    // that.dataArrayList.forEach(it => {
    //   if(it.id !==item.id) {
    //       it.checked = false;
    //     }
    // })
  //  }
   
    console.log(item,"当前的id集合：");
  }
  onInputNUm(item,event) {
    
    const that=this;
     if(event.target.value){
  
      console.log(event.target.value);
      let numvalue: any = that.com.GetNumber(event.target.value);
      console.log(numvalue,"000000000000000");
      
        // if(numvalue >item.Stock){
          
        //   event.target.value = item.Stock;
        //   item.Num = item.Stock;
        // }
      setTimeout(() => {
        if (event.target.value) {
          console.log(numvalue);
          if (numvalue) {
            if(numvalue >item.Stock){
                event.target.value = item.Stock;
                item.Num = item.Stock;
            }else{
              event.target.value = numvalue;
              item.Num = numvalue;
            }
          } else {
            item.Num = 0;
            event.target.value = 0;
          }
        } else {
          event.target.value = null;
          item.Num = 0;
        }
        if(item.Num){
          if(!item.checked){
            item.checked=true;
          }
        }else{
          if(item.checked){
            item.checked=false;
          }
        }
        // input.blur();
      },100);
     }else{
      item.Num = 0;
      if(item.checked){
        item.checked=false;
      }
     }
  }
  focusOrBlurEvent(){
    return;
  }
  /**
   * 全选
   * @param e 
   */
  checkEvent(e) {
    const that=this;
    console.log("门店类型");
    const check = e.target.checked;
    that.dataArrayList[that.typeCode].forEach(item=>{
      item.checked=check;
    });
    that.checkedAll=check;
  }

  

 
}
